export default __webpack_public_path__ + "d32f7d87762bcc6fbd927790ae2b8c77.svg";